import styled, { css } from "styled-components";

export const FilterByDaysWrapper = styled.article`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  gap: 20px;
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  color: ${({ theme }) => theme.old.colors.gray[450]};

  ${({ theme }) => theme.old.breakpoints.isTab} {
    flex-direction: column;
  }
`

export const StatsWrapper = styled.article`
  display: flex;
  gap: 20px;
  margin-bottom: 32px;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    flex-direction: column;
    gap: 35px;
  }
`

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  position: relative;

  border-radius: 12px;
  padding: 24px 24px 35px;
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.05);

  background-color: ${({ theme }) => theme.old.colors.white};

  &::after {
    content: '';
    background-image: ${({ icon }) => `url(${icon})`};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    width: 64px;
    height: 64px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 24px;
    border-radius: 50%;

    ${({ theme }) => theme.old.breakpoints.isTabLand} {
      top: 0;
      left: 24px;
      width: 32px;
      height: 32px;
      box-shadow: 0px 1px 5px rgba(0,0,0,.1);
    }
  }

  h3 {
    font-size: ${({ theme }) => theme.old.fonts.size.smaller};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    color: ${({ theme }) => theme.old.colors.gray[450]};
    margin-bottom: 5px;
  }
  
  p {
    font-size: ${({ theme }) => theme.old.fonts.size.huge};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    color: ${({ theme }) => theme.old.colors.gray[100]};

    display: flex;
    align-items: center;
    gap: 5px;
  }

  span {
    font-size: ${({ theme }) => theme.old.fonts.size.small};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    color: ${({ theme }) => theme.old.colors.gray[450]};
  }
`

export const ListWrapper = styled.article`
  border-radius: 12px;
  width: 100%;
  /* overflow: hidden; */
`

export const ListFilters = styled.div`
  padding: 20px 24px;
  background-color: ${({ theme }) => theme.old.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ViewSelectorWrapper = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: ${({ theme }) => theme.old.fonts.size.smaller};
  color: ${({ theme }) => theme.old.colors.gray[400]};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
`

/**
 *
 * COLUMNS STYLES
 *
 */

export const ContentStyled = styled.div`
  display: flex;
  align-items: center;

  p {
    word-break: break-word;
  }

  img {
    min-height: 54px;
    height: 54px;
    min-width: 96px;
    width: 96px;

    border-radius: 6px;
    object-fit: cover;
    object-position: center;

    margin-right: 16px;
  }

  &:first-child {
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  }
`

export const StatusStyled = styled.div`
  display: flex;
  align-items: center;

  color: ${({ theme, isGray}) => isGray && theme.old.colors.gray[450]};
`

export const StatusCircle = styled.div`
  background-color: ${({ theme, value }) => theme.old.colors.status[value]};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 12px;
`

export const ReleaseDateStyled = styled.div`
  color: ${({ theme, isGray}) => isGray && theme.old.colors.gray[450]};
`

export const PurchasesStyled = styled.div`
  color: ${({ theme, isGray}) => isGray && theme.old.colors.gray[450]};
`

export const PriceStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;

  ${({ theme, isGray}) => isGray && css`
    color: ${theme.old.colors.gray[450]};
  `}
`

export const EarningStyled = styled.div`
  background-color: ${({ theme }) => theme.old.colors.purple[800]};
  color: ${({ theme }) => theme.old.colors.purple[500]};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  border-radius: 6px;
  padding: 6px 12px;
  display: flex;
  gap: 3px;
  align-items: center;

  ${({ theme, isGray}) => isGray && css`
    color: ${theme.old.colors.gray[450]};
    background-color: ${theme.old.colors.gray[750]};
  `}
`

export const PauseTooltipContent = styled.div`
  h4 {
    color: ${({ theme }) => theme.old.colors.gray[100]};
    font-size: ${({ theme }) => theme.old.fonts.size.normal};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    margin-bottom: 8px;
  }
  
  p {
    color: ${({ theme }) => theme.old.colors.gray[450]};
    font-size: ${({ theme }) => theme.old.fonts.size.smaller};
    font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
    margin-bottom: 16px;
  }
  
  a {
    color: ${({ theme }) => theme.old.colors.primary};
    font-size: ${({ theme }) => theme.old.fonts.size.smaller};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  }
`

export const ErrorCardContainer = styled.div`
  margin: auto;
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 800px;
`